import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Card, EmptyState } from "@/components/admin/AdminUI";

export default function WhatsAppAdmin() {
  const [clicks, setClicks] = useState([]);
  useEffect(() => { api.get("/admin/whatsapp").then(({ data }) => setClicks(data)).catch(() => {}); }, []);

  const bySource = clicks.reduce((acc, c) => { const s = c.source || "site"; acc[s] = (acc[s] || 0) + 1; return acc; }, {});

  return (
    <div>
      <PageHeader title="WhatsApp" subtitle="Contacts et clics générés par le site via WhatsApp." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Card className="p-5"><div className="w-10 h-10 rounded-xl bg-[#25D366]/20 grid place-items-center"><MessageCircle className="w-5 h-5 text-[#25D366]" /></div><div className="mt-4 text-3xl font-bold text-white">{clicks.length}</div><div className="text-sm text-slate-400">Clics totaux</div></Card>
        {Object.entries(bySource).slice(0, 3).map(([s, n]) => (
          <Card key={s} className="p-5"><div className="text-3xl font-bold text-white">{n}</div><div className="text-sm text-slate-400 capitalize mt-1">Source : {s}</div></Card>
        ))}
      </div>
      <Card className="overflow-hidden">
        {clicks.length === 0 ? <EmptyState text="Aucun clic WhatsApp enregistré." /> : (
          <div className="overflow-x-auto"><table className="w-full text-sm" data-testid="whatsapp-table">
            <thead><tr className="border-b border-[#1E293B] text-left text-slate-400"><th className="px-4 py-3">Page d'origine</th><th className="px-4 py-3">Solution</th><th className="px-4 py-3">Service</th><th className="px-4 py-3">Source</th><th className="px-4 py-3">Date</th></tr></thead>
            <tbody>{clicks.map((c) => (
              <tr key={c.id} className="border-b border-[#1E293B]/60">
                <td className="px-4 py-3 text-white">{c.page_origine || "—"}</td>
                <td className="px-4 py-3 text-slate-300">{c.solution || "—"}</td>
                <td className="px-4 py-3 text-slate-300">{c.service || "—"}</td>
                <td className="px-4 py-3 text-slate-400">{c.source}</td>
                <td className="px-4 py-3 text-slate-500">{new Date(c.created_at).toLocaleString("fr-FR")}</td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </Card>
    </div>
  );
}
